"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookieService = void 0;
var createCookie = function createCookie(name, value, days) {
  var date = new Date();
  var expires;
  if (days) {
    date = date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=".concat(date.toGMTString());
  } else {
    expires = '';
  }
  document.cookie = "".concat(name, "=").concat(value).concat(expires, "; path=/");
};
var readCookie = function readCookie(name) {
  var expectedCookieName = "".concat(name, "=");
  var cookies = document.cookie.split(';');
  return cookies.reduce(function (cookieValue, cookie) {
    var trimmedCookie = cookie.trim();
    if (cookieValue) return cookieValue; // Return the found value
    return trimmedCookie.indexOf(expectedCookieName) === 0 ? trimmedCookie.substring(expectedCookieName.length) : null; // Continue searching
  }, null);
};
var eraseCookie = function eraseCookie(name) {
  createCookie(name, '', -1);
};
var getCookieService = exports.getCookieService = function getCookieService() {
  return {
    readCookie: readCookie,
    eraseCookie: eraseCookie,
    createCookie: createCookie
  };
};